import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'uxd-design-system-components';
import './StyledModal.scss';
import StyleModalProps from '~types/components/StyleModalProps';
import LocaleContext from '../../contexts/LocaleContext';
import getText from '../../assets/locale/locale';

const StyledModal = ({
  displayModal,
  closeModalHandler,
  headerText,
  paragraphText1,
  paragraphText2,
}: StyleModalProps) => {
  const locId = useContext(LocaleContext);
  const button = {
    text: getText(locId, 'styleModalButton', null),
    onClick: closeModalHandler,
  };
  return (
    <Dialog
      title={headerText}
      open={displayModal}
      buttons={[button]}
      onRequestClose={closeModalHandler}
    >
      {paragraphText1 &&
      paragraphText2 &&
      paragraphText1 !== '' &&
      paragraphText2 !== '' ? (
        <div>
          <p className="modal-paragraph">{paragraphText1}</p>
          <p className="modal-paragraph">{paragraphText2}</p>
        </div>
      ) : (
        <div />
      )}
    </Dialog>
  );
};

StyledModal.defaultProps = {
  paragraphText1: '',
  paragraphText2: '',
};

StyledModal.propTypes = {
  displayModal: PropTypes.bool.isRequired,
  closeModalHandler: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
  paragraphText1: PropTypes.string,
  paragraphText2: PropTypes.string,
};

export default StyledModal;
